import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DashBoardRfariasComponent } from './dashboard-rfarias.component';



@NgModule({
    imports: [RouterModule.forChild([
        { path: '', component: DashBoardRfariasComponent }    
    ])],
    exports: [RouterModule]
})
export class DashBoardRfariasRoutingModule { }
